export default [
  {word: "Machaya", hint:"To do something great"},
  {word: "Makhaya", hint:"To do a task poorly"},
  {word: "Insti Top", hint:"Highest point of KGP"},
  {word: "Gol C", hint:"Here stands BC Roy"},
  {word: "Bhaat", hint:"A local meetup"},
  {word: "Maggu", hint:"A special kind of species with just one goal"},
  {word: "Rassa", hint:"They often conduct strikes in campus :P"},
  {word: "Matka", hint:"Not a UG, not a scholar"},
  {word: "Dassi", hint:"Academic gods"},
  {word: "Peace", hint:"The most famous one"},
  {word: "Illumination", hint:"Lights."},
  {word: "Happa", hint:"Hall president"},
  {word: "Tempo Shout", hint:"We don't scream we have  ____"},
  {word: "Chaggi", hint:"Probably the most common CG"},
  {word: "Panji", hint:"He is a dude"},
  {word: "Faccha", hint:"The noobs of KGP"},
  {word: "Frustapa", hint:"Anxiety and annoyance for a KGPian"},
  {word: "Bhajan", hint:"60% of DC searches"},
];



// WEBPACK FOOTER //
// ./src/components/words.js